import loadable from '@loadable/component';
import React, { useMemo } from 'react';
import { Node_Type } from 'ricos-types';

var DEFAULTS = Object.freeze({
  config: {
    initialExpandedItems: "FIRST",
    expandOnlyOne: false
  }
});

var COLLAPSIBLE_LIST_TYPE = "wix-rich-content-plugin-collapsible-list";

var _nodeViewRenderers;
function _createForOfIteratorHelperLoose$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var CollapsibleListRenderer = function CollapsibleListRenderer(_a) {
  var _b = _a,
    node = _b.node,
    props = __objRest(_b, ["node"]);
  var CollapsibleList = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleList";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_collapsibleList" */'./collapsibleList.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./collapsibleList");
        }
        return eval('require.resolve')("./collapsibleList");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleList, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListLoadable = function CollapsibleListLoadable(_c) {
  var _d = _c,
    node = _d.node,
    props = __objRest(_d, ["node"]);
  return /* @__PURE__ */React.createElement(CollapsibleListRenderer, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListItemRenderer = function CollapsibleListItemRenderer(_e) {
  var _f = _e,
    node = _f.node,
    props = __objRest(_f, ["node"]);
  var CollapsibleListItem = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleListItem";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_collapsibleListItem" */'./collapsibleListItem.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./collapsibleListItem");
        }
        return eval('require.resolve')("./collapsibleListItem");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleListItem, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListItemLoadable = function CollapsibleListItemLoadable(_g) {
  var _h = _g,
    node = _h.node,
    props = __objRest(_h, ["node"]);
  return /* @__PURE__ */React.createElement(CollapsibleListItemRenderer, __spreadValues$1({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleItemPropertyRenderer = function CollapsibleItemPropertyRenderer(_i) {
  var _j = _i,
    node = _j.node,
    type = _j.type,
    props = __objRest(_j, ["node", "type"]);
  var CollapsibleItemProperty = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleListPropertyRenderer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_collapsibleListPropertyRenderer" */'./collapsibleItemProperty.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./collapsibleItemProperty");
        }
        return eval('require.resolve')("./collapsibleItemProperty");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleItemProperty, __spreadProps(__spreadValues$1({
    key: node.id,
    node: node
  }, props), {
    type: type
  }));
};
var CollapsibleItemTitlePropertyLoadable = function CollapsibleItemTitlePropertyLoadable(_k) {
  var _l = _k,
    node = _l.node,
    props = __objRest(_l, ["node"]);
  return /* @__PURE__ */React.createElement(CollapsibleItemPropertyRenderer, __spreadProps(__spreadValues$1({
    key: node.id,
    node: node
  }, props), {
    type: "title"
  }));
};
var CollapsibleItemBodyPropertyLoadable = function CollapsibleItemBodyPropertyLoadable(_m) {
  var _n = _m,
    node = _n.node,
    props = __objRest(_n, ["node"]);
  return /* @__PURE__ */React.createElement(CollapsibleItemPropertyRenderer, __spreadProps(__spreadValues$1({
    key: node.id,
    node: node
  }, props), {
    type: "title"
  }));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.COLLAPSIBLE_LIST] = CollapsibleListLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM] = CollapsibleListItemLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM_TITLE] = CollapsibleItemTitlePropertyLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM_BODY] = CollapsibleItemBodyPropertyLoadable, _nodeViewRenderers);

function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginCollapsibleList = function pluginCollapsibleList(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: COLLAPSIBLE_LIST_TYPE,
    nodeViewRenderers: nodeViewRenderers
  };
};

export { COLLAPSIBLE_LIST_TYPE, pluginCollapsibleList };
